import { render, staticRenderFns } from "./rh_diagnostico.vue?vue&type=template&id=e6d2ca8a&scoped=true&"
import script from "./rh_diagnostico.vue?vue&type=script&lang=js&"
export * from "./rh_diagnostico.vue?vue&type=script&lang=js&"
import style0 from "./rh_diagnostico.vue?vue&type=style&index=0&id=e6d2ca8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d2ca8a",
  null
  
)

export default component.exports